import styled from "styled-components"
import Error from "app/components/Error"

export const StyledFormError = styled(Error)`
  margin-top: ${({ theme }) => theme.space[1]};
`
